(function () {
    'use strict';

    angular
        .module('app.alerts')
        .controller('AlertTemplateDetailController', AlertTemplateDetailController);

    AlertTemplateDetailController.$inject = [
        '$state', '$stateParams',
        'bootstrap.dialog', 'common', 'dataservice', '$window', '$timeout'
    ];

    function AlertTemplateDetailController($state, $stateParams,
        bsDialog, common, dataservice, $window, $timeout) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
        var $q = common.$q;
        
        vm.cancel = cancel;
        vm.deleteItem = deleteItem;
        vm.isSaving = false;
        vm.save = save;
        vm.item = undefined;
        vm.isNew = isNew;
        vm.departments = [];
 
        activate();

        function activate() {
            var promises = [getItem(), initLookups()];
            return common.$q.all(promises).then(function (data) {
            }, function (error) { });
            
        }

        function cancel() {
            backToList();
        }

        function backToList() {
            $state.go("alerts.templates");
        }

        function deleteItem() {
            return bsDialog.deleteDialog('Alert Template')
                .then(confirmDelete, function () { });

            function confirmDelete() {
                dataservice.deleteItem("api/Alerts/DeleteTemplate/" + vm.item.UId).then(success).catch(failed);

                function success() {
                    backToList();
                }

                function failed(error) {
                    logger.error(error);
                }
            }
        }

        function isNew() {
            var val = $stateParams.uid; 
            return val === "";
        }

        function initLookups() {
            return dataservice.getItem("api/Departments/Active")
                .then(function (response) {
                    if (response) {
                        vm.departments = response.data;
                        vm.departments.push({ ID: -1, Description: "(all)" });
                    }
                }).catch(function (error) {
                    logger.error('Error loading departments');
                    
                });
        }

        function getItem() {
            var val = $stateParams.uid;
            
            if (val === '') {
                vm.item = {};
                vm.item.DepartmentId = parseInt($window.localStorage.getItem("SevenPointAlertDepartmentId")) || -1;
            }
            else {
                return dataservice.getItem("api/Alerts/Template/" + val)
                    .then(function (response) {
                        if (response) {
                            vm.item = response.data;
                        }
                    })
                    .catch(function (error) {
                        logger.error('Error while getting item with id = ' + val + '; ' + error);
                        $state.go('404');
                    });
            }
        }


        function save() {
            vm.isSaving = true;
            dataservice.saveItem('api/Alerts/SaveTemplate', vm.item).then(function (saveResult) {
                vm.isSaving = false;
                backToList();
            }).catch(function (error) {
                vm.isSaving = false;
            });
        }
       
    }
})();
